import React, { useState, useEffect } from 'react';
import { parseProps, componentIdGenerator } from './@uteis';
import BRMessage from '../../assets/dsgov/js/components/message';
import '../../assets/dsgov/css/components/message.css';

const Message = (_props) => {
  const [componentId] = useState(`message${componentIdGenerator()}`);
  const props = parseProps(_props);

  useEffect(() => {
    new BRMessage('br-message', window.document.querySelector(`.${componentId}`));
  });

  let classes = `br-message ${componentId}`;
  if (props.classes) classes = `${classes} ${props.classes}`;

  const hideClose = props.hideClose ? props.hideClose : false;
  return (
    <div className={classes} role="alert">
      <div className="content">
        {props.content || null}
      </div>
      {!hideClose ? (
        <div className="close">
          <button
            className="br-button circle small"
            type="button"
            aria-label="Fechar"
          >
            <i className="fas fa-times" aria-hidden="true" />
          </button>
        </div>
      ) : null}

    </div>
  );
};

export default Message;
